import axios from 'axios'
import { queryClient } from './main'

const API_BASE =
  import.meta.env.VITE_API_BASE_URL ??
  (process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : '')

const apiClient = axios.create({
  baseURL: `${API_BASE}/api/v1`,
  //baseURL: import.meta.env.VITE_API_BASE_URL || '/api/v1',
})

apiClient.interceptors.request.use((config) => {
  const raw = localStorage.getItem('userInfo')
  if (raw) {
    const { token } = JSON.parse(raw)
    if (token) config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// === Response: 401 -> on appelle un handler (branché dans StoreProvider)
let onUnauthorized: (() => void) | null = null
export function registerUnauthorizedHandler(fn: () => void) {
  onUnauthorized = fn
}

apiClient.interceptors.response.use(
  (res) => res,
  async (err) => {
    const status = err?.response?.status

    if (status === 403) {
      queryClient.invalidateQueries({ queryKey: ['entitlements'] })
      queryClient.invalidateQueries({ queryKey: ['owner'] })
    }
    if (status === 401 && onUnauthorized) {
      onUnauthorized()
    }
    return Promise.reject(err)
  }
)

export default apiClient
